/* Fantasiewelt Blickfang — schwebende Funken/Glühwürmchen im Hero.
   Leichtgewichtig: pausiert außerhalb des Viewports, respektiert
   prefers-reduced-motion, Partikelzahl abhängig von der Breite.
   Perf: Glow wird einmal als Sprite vorgerendert (kein shadowBlur
   pro Frame), Animation läuft mit 30 fps und startet erst nach dem
   load-Event, damit sie das LCP-Fenster nicht stört. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FRAME_MS = 1000 / 30;
  var initialized = new WeakSet();

  /* Ein Glow-Sprite je Farbe, mit Puffer für den Schein. */
  function makeSprite(color) {
    var size = 32;
    var half = size / 2;
    var c = document.createElement('canvas');
    c.width = size;
    c.height = size;
    var g = c.getContext('2d');
    var grad = g.createRadialGradient(half, half, 0, half, half, half);
    grad.addColorStop(0, 'rgba(' + color + ',1)');
    grad.addColorStop(0.35, 'rgba(' + color + ',0.55)');
    grad.addColorStop(1, 'rgba(' + color + ',0)');
    g.fillStyle = grad;
    g.fillRect(0, 0, size, size);
    return c;
  }

  var SPRITES = null;
  function sprites() {
    if (!SPRITES) {
      SPRITES = {
        gold: makeSprite('255,214,140'),
        violet: makeSprite('205,190,255')
      };
    }
    return SPRITES;
  }

  function initCanvas(canvas) {
    if (initialized.has(canvas)) return;
    initialized.add(canvas);

    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var width = 0;
    var height = 0;
    var particles = [];
    var rafId = null;
    var visible = false;
    var lastFrame = 0;

    function resize() {
      var host = canvas.parentElement;
      if (!host) return;
      var rect = host.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      width = rect.width;
      height = rect.height;
      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      createParticles();
      if (REDUCED) drawFrame(true);
    }

    function createParticles() {
      var count = Math.round(Math.min(48, Math.max(16, width / 30)));
      particles = [];
      for (var i = 0; i < count; i++) {
        particles.push({
          x: Math.random() * width,
          y: Math.random() * height,
          r: 0.8 + Math.random() * 1.9,
          vy: -(0.08 + Math.random() * 0.28),
          vx: (Math.random() - 0.5) * 0.16,
          twinkle: Math.random() * Math.PI * 2,
          twinkleSpeed: 0.024 + Math.random() * 0.06,
          gold: Math.random() < 0.75
        });
      }
    }

    function drawFrame(staticFrame) {
      var s = sprites();
      ctx.clearRect(0, 0, width, height);
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        if (!staticFrame) {
          p.twinkle += p.twinkleSpeed;
          p.x += p.vx * 2;
          p.y += p.vy * 2;
          if (p.y < -5) { p.y = height + 5; p.x = Math.random() * width; }
          if (p.x < -5) p.x = width + 5;
          if (p.x > width + 5) p.x = -5;
        }
        var alpha = staticFrame ? 0.4 : 0.22 + 0.55 * Math.abs(Math.sin(p.twinkle));
        /* Sprite deckt Kern + Glow ab; Zeichengröße ~4× Partikelradius */
        var d = p.r * 4.5;
        ctx.globalAlpha = alpha;
        ctx.drawImage(p.gold ? s.gold : s.violet, p.x - d / 2, p.y - d / 2, d, d);
      }
      ctx.globalAlpha = 1;
    }

    function loop(now) {
      rafId = requestAnimationFrame(loop);
      if (now - lastFrame < FRAME_MS) return;
      lastFrame = now;
      drawFrame(false);
    }

    function start() {
      if (REDUCED || rafId !== null) return;
      rafId = requestAnimationFrame(loop);
    }

    function stop() {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible = entry.isIntersecting;
        if (visible) start();
        else stop();
      });
    }, { threshold: 0.05 });
    observer.observe(canvas);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(resize, 150);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (visible) start();
    });

    resize();
  }

  function initAll() {
    document.querySelectorAll('canvas[data-fantasy-sparkles]').forEach(initCanvas);
  }

  /* Erst nach dem load-Event initialisieren: hält Script-Arbeit und
     Malkosten aus dem kritischen Ladefenster (LCP) heraus. */
  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initAll, { timeout: 2000 });
    } else {
      setTimeout(initAll, 200);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }

  document.addEventListener('shopify:section:load', initAll);
})();
